import React from "react";
import ReactDOM from "react-dom";
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Typography } from "@material-ui/core";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarker, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom';

const styles = theme => ({
  container: {
    fontFamily: 'Roboto',
    color: '#969696'
  },
  textBlock: {
    display: 'inline-block',
    padding: '0 20px',
    color: '#969696'
  },
  copyright: {
    textAlign: 'right',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      paddingTop: 5
    },
  },
  links: {
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  }
});

class AppFooterPortal extends React.Component {
  constructor(props) {
    super(props);

    this.rootSelector = document.getElementById("desktop-footer");
    this.container = document.createElement("div");
  }

  componentDidMount() {
    this.rootSelector.appendChild(this.container);
  }

  componentWillUnmount() {
    this.rootSelector.removeChild(this.container);
  }

  render() {
    const { classes, theme } = this.props;
    const component = (
      <React.Fragment>
        <div className={classes.container}>
          <Grid container>
            <Grid item md={8} lg={7} sm={12} className={classes.links}>
              <Typography className={classes.textBlock} component="a" href="https://www.google.com/maps/dir/?api=1&destination=Carrer De La Diputació, 180, 08011 Barcelona, Spain" target="_blank">
                <FontAwesomeIcon icon={faMapMarker} size="1x" style={{marginRight: 5}} /> C/ Diputación, 180, 6º oficinas B y C 08011 Barcelona
              </Typography>

              <Typography className={classes.textBlock} component="a" href="tel:+34937376400">
                <FontAwesomeIcon icon={faPhone} size="1x" style={{marginRight: 5}} /> 937 37 64 00
              </Typography>

              <Typography className={classes.textBlock} component="a" href="mailto:contact@cosmocare.eu">
                <FontAwesomeIcon icon={faEnvelope} size="1x" style={{marginRight: 5}} /> contact@cosmocare.eu
              </Typography>
            </Grid>
            <Grid item md={4} lg={5} sm={12} className={classes.copyright}>
              <Typography className={classes.textBlock}>
                &copy; 2018 COSMOCARE. Todos los derechos reservados.
              </Typography>
              <Typography className={classes.textBlock} component={Link} to="/aviso-legal">
                Aviso Legal
              </Typography>
            </Grid>
          </Grid>
        </div>
      </React.Fragment>
    );
    return ReactDOM.createPortal(component, this.container);
  }
}

export default withStyles(styles)(AppFooterPortal);


// WEBPACK FOOTER //
// ./src/modules/shared/components/AppFooterPortal.js